/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { reloadUniversalTrackerValues } from './universalTracker';
import { API } from '../constants/errors';
import { getSafeErrorMessage } from './error';
import G17Client, { formDataConfig, formDataHeaders } from '../services/G17Client';
import type { AppDispatch, RootState } from '../reducers';

export const UpdateActions = {
  STATUS: {
    UPDATE: 'update',
    VERIFY: 'verify',
    REJECT: 'reject'
  },
  ACTION: {
    FRAMEWORK: {
      OUTSTANDING: 'outstanding',
      COMPLETED: 'completed'
    },
    UTR: {
      CREATED: 'created',
      VERIFIED: 'verified',
      UPDATED: 'updated',
      REJECTED: 'rejected'
    },
    MESSAGES: {
      'created': 'Not Submitted',
      'verified': 'Verified',
      'updated': 'Pending Verification',
      'rejected': 'Rejected',
    }
  }
};

export function saveUniversalTrackerValue(action: string, utrValueId: string, data: unknown) {
  const url = `/universal-tracker-values/${utrValueId}/${action}`;

  return async (dispatch: AppDispatch, _getState: () => RootState) => {
    return G17Client.patch(url, data, { headers: formDataHeaders })
      .then((result) => {

        dispatch(reloadUniversalTrackerValues());

        return result;
      }).catch(e => {
        throw new Error(getSafeErrorMessage(e));
      });
  }
}

export function createUniversalTrackerValue(data: unknown) {
  const url = '/universal-tracker-values';

  return (dispatch: AppDispatch, _getState: () => RootState) => {

    return G17Client.post(url, data, formDataConfig)
      .then((result) => {

        dispatch(reloadUniversalTrackerValues());
        return result;
      }).catch(e => {
        console.log(e);
        throw new Error(e.response ? API.GENERIC : e.message);
      });
  }
}
